var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"column carousel-slider-container"},[(_vm.makeReportsActive)?_c('ItemMenuSlider',{key:_vm.inner_carusel}):_vm._e(),(!_vm.makeReportsActive)?_c('router-view',{key:_vm.router_view}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }